export { default } from "./Transparency";
